import React, { Component } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { URL } from '../../variables';

class ModalQuestoesDocx extends Component {
    constructor(props) {
        super(props);
        this.state = {
            arquivo: null,
            loading: false,
            mensagem: '',
            erro: '',
            jobId: null,
        };
        this.timeout = null;
    }

    componentWillUnmount() {
        this.clearPoll();
    }

    clearPoll() {
        if (this.timeout != null) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    }

    close() {
        if (this.state.loading) {
            return;
        }

        this.clearPoll();
        this.setState({
            arquivo: null,
            mensagem: '',
            erro: '',
            jobId: null,
        });
        this.props.setShowModal(false);
    }

    upload() {
        if (this.state.arquivo == null) {
            this.setState({ erro: 'Selecione um arquivo DOCX para continuar.' });
            return;
        }

        let data = new FormData();
        data.append('questoes', this.state.arquivo);

        this.clearPoll();
        this.setState({ loading: true, mensagem: 'Carregando arquivo...', erro: '', jobId: null });

        fetch(`${URL}api/faculdade/save_questoes_prova_docx`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${this.props.token}`,
            },
            body: data,
        }).then(async (responseLog) => {
            let resp = await responseLog.json();
            if (resp.errors != null || resp.error != null) {
                let errors = resp.errors != null ? Object.values(resp.errors) : [resp.error];
                this.setState({ loading: false, erro: errors.join('\n'), mensagem: '' });
                return;
            }

            this.setState({ jobId: resp.job_id, mensagem: 'Criando seu banco de questões...' }, () => {
                this.pollJob();
            });
        }).catch((err) => {
            console.log(err);
            this.setState({
                loading: false,
                mensagem: '',
                erro: 'Erro ao enviar arquivo. Você está conectado à internet?',
            });
        });
    }

    pollJob() {
        if (this.state.jobId == null) {
            return;
        }

        fetch(`${URL}api/faculdade/get_questoes_prova_docx_job/${this.state.jobId}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${this.props.token}`,
            },
        }).then(async (responseLog) => {
            let resp = await responseLog.json();
            if (resp.errors != null || resp.error != null) {
                let errors = resp.errors != null ? Object.values(resp.errors) : [resp.error];
                this.setState({ loading: false, erro: errors.join('\n'), mensagem: '' });
                return;
            }

            if (resp.status === 'Finalizado') {
                this.clearPoll();
                this.setState({ loading: false, mensagem: '', erro: '', arquivo: null, jobId: null });
                this.props.saveQuestoes(resp.questoes || []);
                return;
            }

            if (resp.status === 'Erro na execução') {
                this.clearPoll();
                this.setState({
                    loading: false,
                    mensagem: '',
                    erro: resp.error_friendly || resp.error_message || 'Erro ao importar questões.',
                });
                return;
            }

            this.setState({ mensagem: resp.mensagem || 'Processando questões...' });
            this.timeout = setTimeout(() => this.pollJob(), 15000);
        }).catch((err) => {
            console.log(err);
            this.setState({
                loading: false,
                mensagem: '',
                erro: 'Erro ao consultar processamento. Você está conectado à internet?',
            });
        });
    }

    render() {
        return (
            <Modal
                show={this.props.showModal}
                onHide={() => this.close()}
                size="lg"
                backdrop={this.state.loading ? 'static' : true}
                keyboard={!this.state.loading}
            >
                <Modal.Header closeButton={!this.state.loading}>
                    <Modal.Title>Adicionar questões via DOCX</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        O arquivo deve estar separado por disciplina. Informe o nome da disciplina em uma linha
                        própria, como MATEMÁTICA ou GEOGRAFIA, e cadastre as questões logo abaixo.
                    </p>
                    <p>
                        Baixe o modelo correspondente ao tipo de prova. Provas objetivas aceitam questões
                        objetivas simples e conjuntos; provas dissertativas aceitam apenas questões dissertativas.
                    </p>
                    <p>
                        Para questões objetivas, a alternativa correta deve estar destacada com fundo colorido.
                        Textos-base para conjuntos podem usar a indicação de intervalo de questões.
                    </p>

                    <div style={{ marginBottom: '1rem', display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                        <Button
                            variant="outline-success"
                            href="/Modelo_Questoes_Prova_Objetivas.docx"
                            download
                        >
                            Modelo objetivas
                        </Button>
                        <Button
                            variant="outline-success"
                            href="/Modelo_Questoes_Prova_Objetivas_Conjunto.docx"
                            download
                        >
                            Modelo objetivas e conjunto
                        </Button>
                        <Button
                            variant="outline-success"
                            href="/Modelo_Questoes_Prova_Dissertativas.docx"
                            download
                        >
                            Modelo dissertativas
                        </Button>
                    </div>

                    <Form.Group>
                        <Form.Label>Arquivo DOCX</Form.Label>
                        <Form.Control
                            type="file"
                            accept=".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            disabled={this.state.loading}
                            onChange={(e) => this.setState({ arquivo: e.target.files[0], erro: '' })}
                        />
                    </Form.Group>

                    {this.state.mensagem !== '' && (
                        <div style={{ marginTop: '1rem', display: 'flex', alignItems: 'center' }}>
                            <Spinner animation="border" size="sm" style={{ marginRight: 8 }} />
                            <span>{this.state.mensagem}</span>
                        </div>
                    )}

                    {this.state.erro !== '' && (
                        <div className="alert alert-danger" style={{ marginTop: '1rem', whiteSpace: 'pre-line' }}>
                            {this.state.erro}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" disabled={this.state.loading} onClick={() => this.close()}>
                        Cancelar
                    </Button>
                    <Button variant="success" disabled={this.state.loading} onClick={() => this.upload()}>
                        {this.state.loading && <Spinner animation="border" size="sm" style={{ marginRight: 8 }} />}
                        Enviar arquivo
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ModalQuestoesDocx;
